import es from 'date-fns/locale/es'
import enUS from 'date-fns/locale/en-US'

const dateLocales: { [locale: string]: Locale } = {
    es,
    'en-US': enUS
}
export default dateLocales
